import '../node_modules/core-js/modules/web.dom-collections.iterator.js';
import { useState, useCallback } from 'react';

/**
 * This hook returns an interface to work with the given queue like with a component state
 * It allows updating UI on each queue change
 * @param initialValue
 */
function useQueue(initialValue) {
  const [{
    entries
  }, setQueue] = useState(initialValue);
  const add = useCallback((data, id) => {
    setQueue(queue => queue.add(data, id));
  }, []);
  const remove = useCallback(id => {
    setQueue(queue => queue.remove(id));
  }, []);
  const removeAll = useCallback(() => {
    setQueue(queue => queue.removeAll());
  }, []);
  return {
    add,
    remove,
    removeAll,
    entries
  };
}

export { useQueue };
